import { render, staticRenderFns } from "./PostDetailSchedule.vue?vue&type=template&id=2b2e24f6&scoped=true"
import script from "./PostDetailSchedule.vue?vue&type=script&lang=js"
export * from "./PostDetailSchedule.vue?vue&type=script&lang=js"
import style0 from "./PostDetailSchedule.vue?vue&type=style&index=0&id=2b2e24f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2e24f6",
  null
  
)

export default component.exports